import React from 'react';

import { charts, chartsByTime } from '../../constants/event';
import EventChart from '../../chart/EventChart';
import LabelsWrapper from './LabelsWrapper';

const EventsResult = (props) => {
  const { options } = props;

  return (
    <div>
      {charts.includes(options.view) && <EventChart {...props} />}
      {chartsByTime.includes(options.view) && <LabelsWrapper {...props} />}
    </div>
  );
};

export default EventsResult;
